/*
 * Card versions (ADR 113 — addendum)
 *
 * Dado el product_id de una carta, lista OTRAS impresiones del mismo nombre que
 * están disponibles en la bóveda. Se usa en dos lugares:
 *   - Carrito: bajo una línea agotada, ofrece versiones reales que sí hay.
 *   - Vista de producto: bloque "Otras versiones de esta carta" (siempre que haya).
 *
 * Flujo: CardVault dice QUÉ product_ids son vendibles (regla canónica, autoritativa);
 * la búsqueda nativa de Shopify aporta handle/precio/título; intersectamos por id.
 * Así CardVault no llama a Shopify ni expone precios internos.
 *
 * Expone window.VaultCardVersions = { fetchVersions, renderChips } y auto-inicializa
 * cualquier contenedor [data-vault-versions] de la vista de producto.
 */
(function () {
  var isLocal = window.location.port === '9292' || window.location.hostname === '127.0.0.1';
  var CARDVAULT_ORIGIN = isLocal ? 'http://cards.the-vault.mx:3000' : 'https://cards.the-vault.mx';
  var VERSIONS_URL = CARDVAULT_ORIGIN + '/api/cards/versions';
  var REPORT_URL = CARDVAULT_ORIGIN + '/api/cards/report-discrepancy';

  // Chip neutral (link) del design system: bordeado, no destructivo.
  var CHIP_CSS = 'display:inline-flex;align-items:center;gap:6px;border-radius:8px;' +
    'padding:5px 12px;font-size:12px;font-weight:600;line-height:1.4;color:#111827;' +
    'background:#f3f4f6;border:1px solid #e5e7eb;text-decoration:none;margin:0 8px 8px 0;' +
    'transition:background .15s ease;';
  var CHIP_PRICE_CSS = 'color:#6b7280;font-weight:600;';

  function normProdId(id) {
    id = String(id);
    return id.indexOf('gid://') > -1 ? id.split('/').pop() : id;
  }

  // "Adeline, Resplendent Cathar [Innistrad: Midnight Hunt]" → "Innistrad: Midnight Hunt"
  function extractSet(title) {
    var m = /\[([^\]]+)\]/.exec(title || '');
    return m ? m[1] : (title || '');
  }

  function fmtPrice(p) {
    var n = Number(p);
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2);
  }

  // Reporta a CardVault los productos que reclama vendibles pero Shopify tiene
  // agotados, para que los encole a revisión de datos. Best-effort: si falla, nada.
  function reportDiscrepancies(productIds) {
    try {
      fetch(REPORT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_ids: productIds })
      }).catch(function () {});
    } catch (e) { /* noop */ }
  }

  // Devuelve [{ product_id, title, handle, set, price, url }] de versiones vendibles
  // del mismo nombre, excluyendo el producto de entrada. Best-effort: [] ante error.
  /**
   * `titulo` es el respaldo para la ficha SIN STOCK.
   *
   * CardVault resuelve el nombre de la carta contra su propio inventario, así
   * que una ficha de la que nadie tiene copia no tenía nombre que buscar y el
   * módulo no aparecía — justo donde más sirve, porque la pregunta entera ahí es
   * cuál versión SÍ se puede comprar. El Liquid solo lo pone en singles.
   */
  function fetchVersions(productId, titulo) {
    var current = normProdId(productId);
    var url = VERSIONS_URL + '?product_id=' + encodeURIComponent(current);
    if (titulo) url += '&name=' + encodeURIComponent(titulo);
    return fetch(url, {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.name || !Array.isArray(data.product_ids)) return [];
        var allow = {};
        data.product_ids.forEach(function (id) { allow[normProdId(id)] = true; });
        delete allow[current];
        var ids = Object.keys(allow);
        if (!ids.length) return [];

        return fetch('/search/suggest.json?q=' + encodeURIComponent(data.name) +
          '&resources[type]=product&resources[limit]=10', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (s) {
            var products = (s && s.resources && s.resources.results && s.resources.results.products) || [];
            var byId = {};
            products.forEach(function (p) { byId[normProdId(p.id)] = p; });
            var out = [];
            var discrepancies = []; // CardVault dice vendible pero Shopify NO comprable
            ids.forEach(function (id) {
              var p = byId[id];
              if (!p) return; // Shopify no lo conoce en la búsqueda: ambiguo, ni mostrar ni reportar
              // Verificar contra la verdad de Shopify: si está agotado allá, NO recomendar.
              // Es la discrepancia que queremos cazar (probable dato fantasma en CardVault).
              if (!p.available) {
                discrepancies.push(id);
                return;
              }
              out.push({
                product_id: id,
                title: p.title,
                handle: p.handle,
                set: extractSet(p.title),
                price: p.price,
                url: '/products/' + p.handle
              });
            });
            if (discrepancies.length) reportDiscrepancies(discrepancies);
            out.sort(function (a, b) { return (Number(a.price) || 0) - (Number(b.price) || 0); });
            return out;
          })
          .catch(function () { return []; });
      })
      .catch(function () { return []; });
  }

  // Pinta los chips-link en un contenedor. Devuelve cuántos pintó.
  function renderChips(container, versions) {
    if (!container || !versions || !versions.length) return 0;
    versions.forEach(function (v) {
      var a = document.createElement('a');
      a.href = v.url;
      a.className = 'vault-version-chip';
      a.style.cssText = CHIP_CSS;
      a.appendChild(document.createTextNode(v.set || v.title));
      if (v.price) {
        var price = document.createElement('span');
        price.style.cssText = CHIP_PRICE_CSS;
        price.textContent = fmtPrice(v.price);
        a.appendChild(price);
      }
      container.appendChild(a);
    });
    return versions.length;
  }

  // Auto-init de la vista de producto: por cada [data-vault-versions] con
  // data-product-id, busca otras versiones y muestra el bloque si hay (opción i:
  // siempre que existan versiones vendibles, sin importar si la actual está o no).
  function initProductBlocks() {
    var blocks = document.querySelectorAll('[data-vault-versions]');
    blocks.forEach(function (block) {
      if (block.dataset.vaultVersionsDone) return;
      block.dataset.vaultVersionsDone = '1';
      var productId = block.getAttribute('data-product-id');
      // Ausente si el producto no es un single de Magic: el Liquid decide.
      var titulo = block.getAttribute('data-product-title');
      var list = block.querySelector('.vault-versions__list');
      if (!productId || !list) return;
      fetchVersions(productId, titulo).then(function (versions) {
        if (renderChips(list, versions) > 0) block.style.display = '';
      });
    });
  }

  window.VaultCardVersions = { fetchVersions: fetchVersions, renderChips: renderChips };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductBlocks);
  } else {
    initProductBlocks();
  }
})();
